module.exports = "https://neera-retreat.sgp1.cdn.digitaloceanspaces.com/assets/eat-drinks/EATDRINKS_03-localingredients_02.png";